<template>
  <div>
    <v-row>
      <v-col cols="12">
        <EmployeeProfilesTableHeadingAndSearch
          :disabled="disableSearch"
          @filter="filterBy"
        />
      </v-col>

      <v-col v-if="!isOrganizationManager" cols="12">
        <EmployeeProfilesTableFilters @filter="filterBy" :loading="loading" />
      </v-col>

      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card flat class="rounded-lg primary--text mt-3 px-md-2 mouse-cursor">
          <v-row align="center">
            <v-col cols="1" md="1" class="text-start ps-7">
              <div class="d-flex align-center">
                <v-checkbox
                  :input-value="isAllSelected"
                  @change="updateSelection(dataList, $event)"
                  :disabled="!dataList || !dataList.length"
                />

                {{ $t("all") }}
              </div>
            </v-col>

            <v-col cols class="text-start">
              {{ $t("user.registration.organization") }}
            </v-col>

            <v-col cols class="text-start">
              {{ $t("reports.employee") }}
            </v-col>

            <v-col cols="3" class="text-start">
              {{ $t("user.certificatesAndProfileCard.contactNumber") }}
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-row v-if="!loading && dataList.length">
          <v-col cols="12" v-for="(data, index) in dataList" :key="index">
            <EmployeeProfilesTableRow
              :data="data"
              :isSelected="haveSelected(data)"
              @onChange="value => updateSelection([data], value)"
            />
          </v-col>
        </v-row>

        <v-row
          v-else-if="!loading && !dataList.length"
          class="textLight--text font-weight-medium my-16"
          align="center"
        >
          <v-col cols="12">
            {{ $t("noItems") }}
          </v-col>
        </v-row>

        <v-row v-else-if="loading && !dataList.length" class="my-16">
          <v-col cols="12">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" v-if="dataList && dataList.length">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>

      <v-col cols="12" v-if="dataList && dataList.length">
        <div class="d-flex justify-end">
          <v-checkbox
            v-model="downloadAsImage"
            hide-details
            dense
            :label="$t('downloadAsImage')"
            class="caption me-3"
          ></v-checkbox>

          <BulkDownloadButton
            :selections="selections"
            :downloading="downloading"
            @onClear="selections = []"
            @onClick="bulkDownload"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import EmployeeProfilesTableHeadingAndSearch from "./CertificatesTableHeadingAndSearch";
import EmployeeProfilesTableFilters from "./EmployeeProfilesTableFilters";
import EmployeeProfilesTableRow from "@/app/user-module/components/certificate-and-profile-card/EmployeeProfilesTableRow";
import BulkDownloadButton from "@/app/core-module/components/BulkDownloadButton";
import Pagination from "../../../core-module/components/Pagination.vue";

import { bulkDownloadProfileCards } from "@/app/user-module/helpers/profileCardHelper";

export default {
  name: "EmployeeProfilesTable",
  components: {
    EmployeeProfilesTableHeadingAndSearch,
    EmployeeProfilesTableFilters,
    EmployeeProfilesTableRow,
    BulkDownloadButton,
    Pagination,
  },
  data() {
    return {
      loading: true,
      variables: {
        limit: 10,
        skip: 0,
      },
      dataList: [],
      totalCount: null,
      search: null,
      disableSearch: false,
      organization: null,
      selections: [],
      downloading: false,
      downloadAsImage: true,
      subscriberInfo: null,
      totalPages: 0,
    };
  },
  computed: {
    isOrganizationManager() {
      return (
        this.$store.state.authenticatedUser?.isOrganizationManager ?? false
      );
    },
    isAllSelected() {
      return (
        this.selections?.length &&
        this.dataList?.length &&
        this.dataList?.every(x => this.haveSelected(x))
      );
    },
  },
  apollo: {
    getEmployeeProfiles() {
      return {
        query: require("../../api/query/getEmployeeProfiles.gql"),
        variables: this.variablesDefaultValue(),
        result({ data, loading }) {
          if (data?.getEmployeeProfiles?.employees) {
            this.dataList = data.getEmployeeProfiles.employees;
            this.totalCount = data.getEmployeeProfiles.totalCount;
            let pagesVal = this.totalCount / this.variablesDefaultValue().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
          }

          this.loading = loading;
        },
      };
    },
    getSubscriberProfile() {
      return {
        query: require("../../api/query/getSubscriberProfile.gql"),
        result({ data }) {
          if (data?.getSubscriberProfile) {
            this.subscriberInfo = data.getSubscriberProfile;
          }
        },
      };
    },
  },
  methods: {
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    haveSelected(obj) {
      return this.selections?.findIndex(x => x._id === obj._id) >= 0;
    },
    updateSelection(list, isSelected) {
      list.forEach(obj => {
        const existingIndex = this.selections.findIndex(x => x._id === obj._id);

        if (isSelected) {
          if (existingIndex < 0) {
            this.selections.push(obj);
          }
        } else {
          if (existingIndex >= 0) {
            this.selections.splice(existingIndex, 1);
          }
        }
      });
    },
    bulkDownload() {
      this.downloading = true;

      bulkDownloadProfileCards({
        employeeProfiles: this.selections,
        subscriberInfo: this.subscriberInfo,
        image: this.downloadAsImage,
      }).then(response => {
        if (response) this.selections = [];
        this.downloading = false;
      });
    },
    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    variablesDefaultValue() {
      return {
        limit: 10,
        skip: 0,
      };
    },
    filterBy(key, value) {
      if (key === "search") this.search = value;
      if (key === "organization") this.organization = value;

      this.variables.limit = 10;
      this.variables.skip = 0;

      this.refetch();
    },
    async refetch() {
      await this.$apollo.queries.getEmployeeProfiles.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: {
          search: this.search ? this.search : null,
          organization: this.organization ? this.organization : null,
        },
      });
    },
  },
};
</script>
